import styled from 'styled-components';

export const ContentWrapper = styled.div`
  padding: 24px 32px;
  background: rgb(240, 239, 241);
  min-height: calc(100vh - 300px);
`;

/** Link that opens Audience Studio editor in a new tab (Edit Audience per export row) */
export const EditAudienceLink = styled.a`
  color: #1976d2;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

